/**
 * Tells webpack to prefix any injected scripts, css, or images with the
 * CDN_PREFIX. For example, some webpack loaders and webpack's code splitting
 * functionality will inject files.
 * 
 * @note This file isn't transpiled so make sure you don't use any es6 features
 * here
 *
 * @see https://v4.webpack.js.org/guides/public-path/#on-the-fly
 */
var oldPublicPath = (typeof __webpack_public_path__ !== 'undefined') ? (__webpack_public_path__ || '/') : '/';
var cdnPrefix = window.CDN_PREFIX || '';

if (typeof oldPublicPath === 'string' && oldPublicPath[0] === '/') {
  __webpack_public_path__ = (cdnPrefix + oldPublicPath);
}
